import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import {
	Typography,
	Grid,
	Fade,
	Backdrop,
	Modal,
	Button,
	IconButton
} from "@mui/material";

import AutoComplete from "Components/AutoComplete";

import { MdAdd } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import ls from "Localization";
import Spinner from "Components/Spinner";
import { State } from "store/reducers";
import { BankBilletDetailState } from "store/reducers/bankBillet/detail";
import TextInput from "Components/TextInput";
import { MONEY } from "Components/NumberFormat";

import _ from "lodash";
import actions from "store/actions";
import { UserState } from "store/reducers/user";

const useStyles = makeStyles((theme: any) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		width: 768,
		padding: theme.spacing(1, 2)
	},
	body: {
		padding: theme.spacing(2, 0)
	},
	footer: {
		display: "flex",
		justifyContent: "flex-end",
		padding: theme.spacing(1),
		"& button": {
			marginLeft: theme.spacing(1)
		}
	}
}));

let debounceFindUser: (() => any) & _.Cancelable;

function CreateSplit() {
	const classes = useStyles({});
	const dispatch = useDispatch<any>();

	const [open, setOpen] = useState(false);
	const [value, setValue] = useState(0);
	const [user, setUser] = useState("");
	const [errors, setErrors] = useState({});

	const { loading: userLoading } = useSelector<State, UserState>(s => s.user);

	const { item, loading }: any = useSelector<State, BankBilletDetailState>(
		s => s.bankBilletDetail
	);

	console.log(value);

	const findUser = (name: any, callback: any) => {
		if (name.length >= 3) {
			if (debounceFindUser) debounceFindUser.cancel();

			debounceFindUser = _.debounce(() => {
				dispatch(
					actions.user.getUsers(
						0,
						10,
						`&filters[searchText]=${name}&filters[roles]=mei`,
						undefined,
						false,
						false,
						(errors, models) => {
							if (models) {
								callback(
									models.map(c => ({
										id: c._id,
										label: `${c.name} ${c.lastname}`
									}))
								);
							} else {
								callback([]);
							}
						}
					)
				);
			}, 1000);

			debounceFindUser();
		}
	};

	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.bankBillet.detail.createSplit(
				item._id,
				{
					user,
					value: Math.round(value * 100)
				},
				err => {
					if (err) {
						console.log(err);
						alert(err);
					} else {
						setOpen(false);

						dispatch(actions.bankBillet.detail.getSplits(item._id));
					}
				}
			)
		);
	};

	return (
		<div>
			<IconButton onClick={() => setOpen(o => !o)}>
				<MdAdd />
			</IconButton>
			<Modal
				aria-labelledby="edit-create-split-modal-title"
				aria-describedby="edit-create-split-modal-description"
				className={classes.modal}
				open={open}
				onClose={() => setOpen(false)}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<Typography variant="h6">Criar split</Typography>
						<hr />
						<div className={classes.body}>
							<form noValidate onSubmit={onSubmit}>
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<AutoComplete
											id="user"
											name="user"
											errors={errors}
											onChange={(_: any, v: any) => setUser(v)}
											loadOptions={findUser}
											loading={userLoading}
											filterOptions={(options: any, state: any) => {
												return options;
											}}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<TextInput
											id="value"
											required
											variant="outlined"
											name="value"
											InputProps={{
												inputComponent: MONEY
											}}
											value={value}
											errors={errors}
											onFocus={e => e.target.select()}
											onChange={(_, v) => setValue(+v)}
										/>
									</Grid>
								</Grid>
								<div className={classes.footer}>
									<Button variant="contained" onClick={() => setOpen(false)}>
										{ls.cancel}
									</Button>
									<Button
										color="primary"
										variant="contained"
										type="submit"
										disabled={loading.split}
									>
										{ls.save}
										{loading.split && <Spinner color="secondary" size={20} />}
									</Button>
								</div>
							</form>
						</div>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}

export default CreateSplit;
